export default "__VITE_ASSET__Cr7YCZIp__"